import { useQuery } from '@tanstack/react-query';
import { inspectionDB } from '../data/database.structure';
import { PartTypeModel } from '../data/types';

/**
 * GET part types are reference data (they change only on a full sync), but the old
 * useState + useEffect version re-read them from IndexedDB on EVERY mount and rendered
 * an empty-array frame first - one of the staggered "waves" that made ToC screens
 * flicker. Cached query: warm mounts get the list synchronously on the first frame.
 */
const useBucketGETPartTypes = () => {
  const { data } = useQuery({
    queryKey: ['bucketGETPartTypes'],
    queryFn: async () => {
      const partTypes = await inspectionDB.partTypes.toArray();
      const partCategories = await inspectionDB.partCategories.toArray();

      const getPartCategory = partCategories.find(
        (partCategory) =>
          partCategory.name.toLowerCase() === 'ground engaging tools',
      );

      return partTypes.filter(
        (partType) => partType.categoryId === getPartCategory?.id,
      );
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    networkMode: 'always',
  });

  return { bucketGETPartTypes: (data ?? []) as PartTypeModel[] };
};

export default useBucketGETPartTypes;
